import { render, staticRenderFns } from "./epod-tab.vue?vue&type=template&id=01692424"
import script from "./epod-tab.vue?vue&type=script&lang=js"
export * from "./epod-tab.vue?vue&type=script&lang=js"
import style0 from "./epod-tab.vue?vue&type=style&index=0&id=01692424&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports